import * as React from 'react';
import classnames from 'classnames';
import { Carousel } from '@grandvisionhq/common';
import { UspGroupItem } from './UspGroupItem.js';

const UspGroup = ({ items =[] , theme ='light' , onPrevSlide , onNextSlide ,  })=>{
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('usp-group', {
            'usp-group--light': theme === 'light'
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container desktop-hidden"
    }, /*#__PURE__*/ React.createElement(Carousel, {
        navigation: true,
        inverseColor: theme !== 'light',
        pagination: false,
        onPrevSlide: onPrevSlide,
        onNextSlide: onNextSlide
    }, items.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    ))), /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container mobile-hidden"
    }, items.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )));
};

export { UspGroup, UspGroup as default };
//# sourceMappingURL=UspGroup.js.map
